<div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
    <span>{{ displayValue }}</span>
    <button (click)="editData(params)" title="Edit" *ngIf="isEditVisible" style="padding: 0 4px;">
        <img src="/assets/edit.svg" height="20" width="18" alt="Edit Icon" />
    </button>
</div>